import { HeroEventProps } from '@sbercloud/uikit-product-site-hero';

import { EventType } from '../../../../types/backendContent';

export const getPlaceProps = (
  dto?: EventType['place'],
): HeroEventProps['place'] => {
  return {
    title: dto?.title,
    href: dto?.link,
  };
};
